import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class Xc47Mast extends Component {
    constructor(props) {
        super(props);
        this.handleMastAndBoomChange = this.handleMastAndBoomChange.bind(this);
        this.handleBoomChange = this.handleBoomChange.bind(this);
    }

    handleMastAndBoomChange(newValue) {
        let configuration = this.props.configuration;
        configuration.MastAndBoom = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleBoomChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Boom = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
		let imageOptions = exterior_view01ImageOptions;

		let image = (
			<TransomConfigurator colorMultiplier={0.75} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 2240, height: 1050 }} transform={
				[
					0.018568, 0.008687, 0, -0.000004,
					-0.001859, 0.048716, 0, -0.000021,
					0, 0, 1, 0,
					131, 292, 0, 1
				]}>
				<ConfiguratorImage boat="Xc47" configuration={this.props.configuration} options={imageOptions} />
			</TransomConfigurator>
		);

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
					<h1><Trans defaults='Mast & Boom' /></h1>

					<h2><Trans defaults='Finish' /></h2>

                    <RadioGroup options={this.props.mastAndBoomOptions} value={this.props.configuration.MastAndBoom} onChange={this.handleMastAndBoomChange} />

                    <RadioGroup options={this.props.boomOptions} value={this.props.configuration.Boom} onChange={this.handleBoomChange} />
					<p><Trans defaults='* Not visualized in rendering. Please contact your local dealer for further information' /></p>


                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Xc47Mast);


// WEBPACK FOOTER //
// ./src/Xc47/Xc47Mast.js